module.exports = __webpack_public_path__ + "static/media/bloodywood.867db830.png";